import * as yup from 'yup'

export const saleSchema = yup.object().shape({
  tipoVenda: yup.string().required('Selecione um tipo de venda.'),
  data: yup.date().required('Data da venda é obrigatória').typeError('Data da venda é obrigatória'),
  idLote: yup.string().when('tipoVenda', {
    is: 'lote',
    then: yup.string().required('Lote é obrigatório.'),
    otherwise: yup.string().nullable()
  }),
  animais: yup.array().when('tipoVenda', {
    is: 'animal',
    then: yup.array().required('Animal é obrigatório.').min(1, 'Animal é obrigatório'),
    otherwise: yup.array().nullable()
  }),
  valorArroba: yup.string().when('tipoVenda', {
    is: 'lote',
    then: yup.string().required('Valor da arroba é obrigatório.'),
    otherwise: yup.string().nullable()
  }),
  valorTotal: yup.string().when('tipoVenda', {
    is: 'animal',
    then: yup.string().required('Valor total é obrigatório.'),
    otherwise: yup.string().nullable()
  }),
  comprador: yup.string().nullable()
})

export default saleSchema
